__webpack_require__.p = "/durer-jatekok-new/";